var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDeclineRequest(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 10.7452 10.7452 0 24 0C37.2548 0 48 10.7452 48 24C48 37.2548 37.2548 48 24 48C10.7452 48 0 37.2548 0 24Z",
    fill: "#FEE4E2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 18V17.2C28 16.0799 28 15.5198 27.782 15.092C27.5903 14.7157 27.2843 14.4097 26.908 14.218C26.4802 14 25.9201 14 24.8 14H23.2C22.0799 14 21.5198 14 21.092 14.218C20.7157 14.4097 20.4097 14.7157 20.218 15.092C20 15.5198 20 16.0799 20 17.2V18M22 23.5V28.5M26 23.5V28.5M15 18H33M31 18V29.2C31 30.8802 31 31.7202 30.673 32.362C30.3854 32.9265 29.9265 33.3854 29.362 33.673C28.7202 34 27.8802 34 26.2 34H21.8C20.1198 34 19.2798 34 18.638 33.673C18.0735 33.3854 17.6146 32.9265 17.327 32.362C17 31.7202 17 30.8802 17 29.2V18",
    stroke: "#D92D20",
    strokeWidth: "1.5px",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeclineRequest);
export default __webpack_public_path__ + "static/media/decline-request.b0dacc9db4ed89a7c7c5ec2745fc6a2f.svg";
export { ForwardRef as ReactComponent };